import React from 'react';
import {FormRendererProps} from '../../@types/components/Form';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';
import ErrorRepresentation from '../ErrorRepresentation/ErrorRepresentation';
import FormControls from '../Form/FormControls';
import NestedFormFields from './NestedFormFields';

export default function NestedFormRenderer<Model extends IEmptyModel = IEmptyModel>(props: FormRendererProps<Model>) {
    const FieldsComponent = props.fieldsComponent ?? NestedFormFields;
    const ControlsComponent = props.controlsComponent ?? FormControls;

    return <>
        {props.error ? (
                <ErrorRepresentation
                        error={props.error as Error}
                        outsideContainer={true}
                        className="mb-3"
                />
        ) : null}

        <FieldsComponent<Model>
                config={props.config}
                context={props.context}
                model={props.model}
                modelOptions={props.modelOptions}
                formName={props.formName}
                customFields={props.customFields}
        />

        {props.config.controls ? (
                <ControlsComponent {...props.config} formName={props.formName}/>
        ) : null}

        {props.controls}
    </>;
}
